import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class ContactAPI {

    constructor(http) {
        this.http = http
    }
    getBusinessTypes(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });
        this.http.post('api/contact/getBusinessTypes')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("business_types"))
                        successCallback(json.business_types);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    getList(token, data,page,limit, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        var queryString = "?page=" + page;
        queryString += "&limit=" + limit;

        this.http.post('api/contact/getList'+queryString, data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("contacts"))
                        successCallback(json.contacts);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    save(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/save', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("contacts"))
                        successCallback(json.contacts);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    delete(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/delete', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("contacts"))
                        successCallback(json.contacts);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    bulkDelete(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/bulkDelete', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("contacts"))
                        successCallback(json.contacts);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    //Group Related Functions
    saveGroup(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/addGroup', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    deleteGroup(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/deleteGroup', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    getGroupList(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/contact/groupList')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getGroupListWithPagination(page, limit, sortBy, sortDir,token, successCallback, errorCallback) {

      this.http = this.http.configure(x => {
          x.withHeader('Content-Type', 'application/json')
          .withHeader("Authorization", token);

      });

      var queryString = "?page=" + page;
      queryString += "&limit=" + limit;
      queryString += "&sortBy=" + sortBy;
      queryString += "&sortDir=" + sortDir;
      this.http.get('api/contact/groupList'+queryString)
          .then(data => {

              if (data.isSuccess) {
                  var json = JSON.parse(data.response);

                  if(json.hasOwnProperty("groups"))
                      successCallback({groups:json.groups,count:json.count});

                  if(json.hasOwnProperty("error"))
                      errorCallback(json.error);

              }
              else {
                  errorCallback(data.statusText);
              }
          });

  }
    //Group Related Functions
     upload_csv(logo_file, data, token, successCallback, errorCallback) {

        //console.log("data in save", data);
        //console.log(profile_image);
        console.log(logo_file);
        var formData = new FormData();
        formData.append('group_details', JSON.stringify(data));
        if (logo_file != null)
            formData.append('logo_file', logo_file);

        //if (profile_image != null)
            //formData.append('profile_image', profile_image);

        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/contact/uploadCsv', formData)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);
console.log('Response....');
console.log(json);
                    if (json.hasOwnProperty("result"))
                        successCallback(json.result);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
}
